let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dkMQj")).then(() => parcelRequire('31JhY'));